export default {
  listClient(params) {
    return Request.get('api/service/client', params);
  },
  // listIntern() {
  //   return Request.get('api/service/client/intership');
  // },
  detail(id) {
    return Request.get(`api/service/${id}`);
  },
};
